export const mandates = [
  {
    id: 1,
    subtypeCode: 'FR_INS_DEC',
    thirdPartyGroup: null,
    creationDate: '2021-06-01T08:28:09.938Z'
  },
  {
    id: 2,
    subtypeCode: 'FR_ASSU_TRANS',
    thirdPartyGroup: null,
    creationDate: '2021-05-30T08:28:09.938Z'
  },
  {
    id: 3,
    subtypeCode: 'FR_COV',
    thirdPartyGroup: 'URSSAF_INDEP',
    creationDate: '2021-05-22T08:28:09.938Z'
  },
  {
    id: 4,
    subtypeCode: 'INS_ASSU_MAT',
    thirdPartyGroup: null,
    creationDate: '2021-05-31T08:28:09.938Z'
  }
];

export const mandateDetails = {
  id: 1315,
  subtypeCode: 'ATTES_RET',
  thirdPartyGroup: 'PROBTP',
  creationDate: '2021-06-14T12:39:55.380647Z',
  scope: 'GROUP',
  organisationIds: [
    7601,
    55301,
    9801,
    9802,
    45403,
    54652,
    58701,
    77454
  ],
  fieldsValues: {
    REGISTRATION_NUMBER: '70204275500125',
    PASSWORD: 'cbp5wt3F40987H5LqBxI2w==',
    LOGIN: '1123456'
  }
};

export const mandateField = {
  secured: false,
  type: 'TEXT',
  key: 'INSURANCE_COMPANY',
  value: 'Field Value'
};

export const mandateFields =
  [
    {
      subtypeCode: 'FR_INS_DEC',
      thirdPartyFields: [
        {
          thirdPartyGroup: null,
          scope: 'GROUP',
          fields: [
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'INSURANCE_COMPANY'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'POLICE_NUMBER'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'FIRST_NAME'
              },
              required: false
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'LAST_NAME'
              },
              required: false
            },
            {
              field: {
                secured: false,
                type: 'EMAIL',
                key: 'EMAIL'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'PHONE',
                key: 'PHONE'
              },
              required: false
            }
          ]
        }
      ]
    },
    {
      subtypeCode: 'FR_ASSU_TRANS',
      thirdPartyFields: [
        {
          thirdPartyGroup: null,
          scope: 'GROUP',
          fields: [
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'INSURANCE_COMPANY'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'POLICE_NUMBER'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'FIRST_NAME'
              },
              required: false
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'LAST_NAME'
              },
              required: false
            },
            {
              field: {
                secured: false,
                type: 'EMAIL',
                key: 'EMAIL'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'PHONE',
                key: 'PHONE'
              },
              required: false
            }
          ]
        }
      ]
    },
    {
      subtypeCode: 'FR_COV',
      thirdPartyFields: [
        {
          thirdPartyGroup: 'URSSAF_INDEP',
          scope: 'GROUP',
          fields: [
            {
              field: {
                secured: true,
                type: 'NUMBER',
                key: 'SOCIAL_SECURITY_NUMBER'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'KEY'
              },
              required: true
            },
            {
              field: {
                secured: true,
                type: 'TEXT',
                key: 'PASSWORD'
              },
              required: true
            }
          ]
        },
        {
          thirdPartyGroup: 'URSSAF_AUTOENT',
          scope: 'GROUP',
          fields: [
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'LOGIN'
              },
              required: true
            },
            {
              field: {
                secured: true,
                type: 'TEXT',
                key: 'PASSWORD'
              },
              required: true
            }
          ]
        },
        {
          thirdPartyGroup: 'URSSAF',
          scope: 'GROUP',
          fields: [
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'LOGIN'
              },
              required: true
            },
            {
              field: {
                secured: true,
                type: 'TEXT',
                key: 'PASSWORD'
              },
              required: true
            }
          ]
        },
        {
          thirdPartyGroup: 'NET_ENTREPRISE',
          scope: 'GROUP',
          fields: [
            {
              field: {
                secured: false,
                type: 'NUMBER',
                key: 'REGISTRATION_NUMBER'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'LAST_NAME'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'FIRST_NAME'
              },
              required: true
            },
            {
              field: {
                secured: true,
                type: 'TEXT',
                key: 'PASSWORD'
              },
              required: true
            }
          ]
        },
        {
          thirdPartyGroup: 'TESE',
          scope: 'GROUP',
          fields: [
            {
              field: {
                secured: false,
                type: 'NUMBER',
                key: 'REGISTRATION_NUMBER'
              },
              required: true
            },
            {
              field: {
                secured: true,
                type: 'TEXT',
                key: 'PASSWORD'
              },
              required: true
            }
          ]
        }
      ]
    },
    {
      subtypeCode: 'INS_RC_PRO',
      thirdPartyFields: [
        {
          thirdPartyGroup: null,
          scope: 'GROUP',
          fields: [
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'INSURANCE_COMPANY'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'POLICE_NUMBER'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'FIRST_NAME'
              },
              required: false
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'LAST_NAME'
              },
              required: false
            },
            {
              field: {
                secured: false,
                type: 'EMAIL',
                key: 'EMAIL'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'PHONE',
                key: 'PHONE'
              },
              required: false
            }
          ]
        }
      ]
    },
    {
      subtypeCode: 'FR_PAY',
      thirdPartyFields: [
        {
          thirdPartyGroup: 'CIBTP',
          scope: 'GROUP',
          fields: [
            {
              field: {
                secured: false,
                type: 'EMAIL',
                key: 'EMAIL'
              },
              required: true
            },
            {
              field: {
                secured: true,
                type: 'TEXT',
                key: 'PASSWORD'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'REGION'
              },
              required: false
            }
          ]
        },
        {
          thirdPartyGroup: 'CNETP',
          scope: 'GROUP',
          fields: [
            {
              field: {
                secured: false,
                type: 'NUMBER',
                key: 'CONVENTION_NUMBER'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'LOGIN'
              },
              required: true
            },
            {
              field: {
                secured: true,
                type: 'TEXT',
                key: 'PASSWORD'
              },
              required: true
            }
          ]
        }
      ]
    },
    {
      subtypeCode: 'ATTES_RET',
      thirdPartyFields: [
        {
          thirdPartyGroup: 'PROBTP',
          scope: 'GROUP',
          fields: [
            {
              field: {
                secured: false,
                type: 'NUMBER',
                key: 'REGISTRATION_NUMBER'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'LOGIN'
              },
              required: true
            },
            {
              field: {
                secured: true,
                type: 'TEXT',
                key: 'PASSWORD'
              },
              required: true
            }
          ]
        }
      ]
    },
    {
      subtypeCode: 'FR_TAX',
      thirdPartyFields: [
        {
          thirdPartyGroup: null,
          scope: 'GROUP',
          fields: [
            {
              field: {
                secured: false,
                type: 'EMAIL',
                key: 'EMAIL'
              },
              required: true
            },
            {
              field: {
                secured: true,
                type: 'TEXT',
                key: 'PASSWORD'
              },
              required: true
            }
          ]
        }
      ]
    },
    {
      subtypeCode: 'ATTES_RET',
      thirdPartyFields: [
        {
          thirdPartyGroup: 'PROBTP',
          scope: 'GROUP',
          fields: [
            {
              field: {
                secured: false,
                type: 'NUMBER',
                key: 'REGISTRATION_NUMBER'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'LOGIN'
              },
              required: true
            },
            {
              field: {
                secured: true,
                type: 'TEXT',
                key: 'PASSWORD'
              },
              required: true
            }
          ]
        }
      ]
    },
    {
      subtypeCode: 'ATTES_PREV',
      thirdPartyFields: [
        {
          thirdPartyGroup: 'PROBTP',
          scope: 'GROUP',
          fields: [
            {
              field: {
                secured: false,
                type: 'NUMBER',
                key: 'REGISTRATION_NUMBER'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'LOGIN'
              },
              required: true
            },
            {
              field: {
                secured: true,
                type: 'TEXT',
                key: 'PASSWORD'
              },
              required: true
            }
          ]
        }
      ]
    },
    {
      subtypeCode: 'FR_ASSU_DEC_OUV',
      thirdPartyFields: [
        {
          thirdPartyGroup: null,
          scope: 'GROUP',
          fields: [
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'INSURANCE_COMPANY'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'POLICE_NUMBER'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'FIRST_NAME'
              },
              required: false
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'LAST_NAME'
              },
              required: false
            },
            {
              field: {
                secured: false,
                type: 'EMAIL',
                key: 'EMAIL'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'PHONE',
                key: 'PHONE'
              },
              required: false
            }
          ]
        }
      ]
    },
    {
      subtypeCode: 'INS_ASSU_MAT',
      thirdPartyFields: [
        {
          thirdPartyGroup: null,
          scope: 'GROUP',
          fields: [
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'INSURANCE_COMPANY'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'POLICE_NUMBER'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'FIRST_NAME'
              },
              required: false
            },
            {
              field: {
                secured: false,
                type: 'TEXT',
                key: 'LAST_NAME'
              },
              required: false
            },
            {
              field: {
                secured: false,
                type: 'EMAIL',
                key: 'EMAIL'
              },
              required: true
            },
            {
              field: {
                secured: false,
                type: 'PHONE',
                key: 'PHONE'
              },
              required: false
            }
          ]
        }
      ]
    }
  ];
